/*
 * @Author: your name
 * @Date: 2021-08-12 00:27:12
 * @LastEditTime: 2021-08-23 01:12:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /private-claim/src/components/index.js
 */
export default function installComponent(Vue) {
  ((r) => {
    r.keys().forEach((componentPath) => {
      const components = r(componentPath);
      const componentsName = componentPath.match(/^\.\/(.+).vue$/)[1];

      Vue.component(componentsName, components.default);
    });
  })(require.context("./", false, /\.vue$/));
}
